<template>
  <div class="mail">
    <c-tab :tabs="tabs"></c-tab>
  </div>
</template>
<script>
import CTab from '@/components/common/tab'
import * as types from '@/store/mutation-types'

export default {
  components: { CTab },
  data () {
    return {
      tabs: [ {
        label: '奖项列表',
        component: () => import('./#list')
      }, {
        label: '我的推荐',
        component: () => import('./#commond')
      }]
    }
  },
  watch: {
    $route: {
      handler: function() {
        const crumbs = {
          path: this.$route.path,
          tabs: this.tabs
        }
        this.$store.commit(types.RECORD_GLOBAL_CRUMBSECOND, crumbs)
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
